import { configureStore } from '@reduxjs/toolkit'
import mailBox from "./stores/mailbox";


export default configureStore({
    reducer: {
        mailBox: mailBox,
    },
})